export enum InformationPage {
  Returns = '3',
  Terms = '5',
  Postage = '6',
  Sizes = '7',
  Cookies = '13',
  ReturnSuccess = '20',
  ReclaimSuccess = '26',
  PrivacyPolicy = '21',
  B2b = '24',
  conditionsOfActions = '27'
}
